import {Injectable} from "@angular/core";
import {StaticsService} from "../sys/statics.service";
import {FilterCategory} from "../model/filterCategory";
import {QueryValue} from "../model/queryValue";


declare var $: any;

@Injectable()
export class FilterManagerService {

    public filterExpanded: boolean[] = new Array();
    private filterCategories: FilterCategory[] = new Array();

    constructor(private staticsService: StaticsService) {
        this.initialize();
    }

    ngOnInit() {

    }

    public getFilterCategory(inFilterCategory: FilterCategory): FilterCategory {
        let foundFilterCategory: FilterCategory;

        for (let filterCategory of this.filterCategories) {
            if (filterCategory.filterType == inFilterCategory.filterType) {
                foundFilterCategory = filterCategory;
            }
        }
        return foundFilterCategory;
    }

    public findFilterCategoryByFilterType(filterType: number): FilterCategory {
        let foundFilterCatergory: FilterCategory;

        for (let filterCategory of this.filterCategories) {
            if (filterCategory.filterType == filterType) {
                foundFilterCatergory = filterCategory;
            }
        }
        return foundFilterCatergory;
    }

    public updateFilterCategory(inFilterCategory: FilterCategory) {
        let newFilterCategories: FilterCategory[] = new Array();
        for (let filterCategory of this.filterCategories) {
            if (filterCategory.filterType == inFilterCategory.filterType) {
                newFilterCategories.push(inFilterCategory)
            }
            else {
                newFilterCategories.push(filterCategory);
            }

        }
        this.filterCategories = newFilterCategories;
    }

    public addFilterCategory(inFilterCategory: FilterCategory) {
        let isFound: boolean = false;

        for (let filterCategory of this.filterCategories) {
            if (filterCategory.filterType == inFilterCategory.filterType) {
                  isFound = true;
            }
        }
        if (!isFound) {
            this.filterCategories.push(inFilterCategory);
        }
    }

    public initialize() {
        this.filterExpanded[this.staticsService.getFilterType().PLAN_YEARS] = false;
        this.filterExpanded[this.staticsService.getFilterType().DEFINED_BENEFIT] = false;
        this.filterExpanded[this.staticsService.getFilterType().DEFINED_CONTRIBUTION] = false;
        this.filterExpanded[this.staticsService.getFilterType().PENSION] = false;
        this.filterExpanded[this.staticsService.getFilterType().WELFARE] = false;
        this.filterExpanded[this.staticsService.getFilterType().ASSETS] = false;
        this.filterExpanded[this.staticsService.getFilterType().PARTICIPANTS] = false;
        this.filterExpanded[this.staticsService.getFilterType().EMPLOYER] = false;
        this.filterExpanded[this.staticsService.getFilterType().BUSINESS] = false;
        this.filterExpanded[this.staticsService.getFilterType().STATES] = false;
        this.filterExpanded[this.staticsService.getFilterType().FOREIGN] = false;
        this.filterExpanded[this.staticsService.getFilterType().ZIPCODE] = false;
        this.filterExpanded[this.staticsService.getFilterType().FORM_YEARS] = false;

    }

    public reset () {
        this.filterExpanded = new Array();
        this.filterCategories = new Array();
    }

    public isExpanded(filterType: number) : boolean {
        return this.filterExpanded[filterType];
    }

    public setIsExpanded(filterType: number, isExpanded: boolean) {
        this.filterExpanded[filterType] = isExpanded;
    }
}
